/* eslint-disable react/forbid-prop-types */
import { createElement } from 'react';
import { createPortal } from 'react-dom';
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';

function App({ wrappers, components }) {
  const content = (
    <>
      {components.map((component) => {
        const { dom, reactElement, reactProps } = component;
        return createPortal(createElement(reactElement, reactProps), dom);
      })}
    </>
  );

  const result = wrappers.reduce((accumulator, currentValue) => {
    const { reactElement, reactProps } = currentValue;
    return createElement(reactElement, reactProps, accumulator);
  }, content);
  return result;
}

App.propTypes = {
  components: PropTypes.array,
};

function ReactOnCms() {
  this.elementMap = {};
  this.wrapperArray = [];

  this.register = (newElements) => {
    this.elementMap = { ...this.elementMap, ...newElements };
  };

  this.addWrapper = ({ reactElement, reactProps }) => {
    this.wrapperArray.push({ reactElement, reactProps });
  };

  this.loadComponents = () => {
    const scriptDoms = Array.from(
      document.querySelectorAll('script[data-react-name]')
    );
    const components = scriptDoms.map((scriptDom) => {
      const reactName = scriptDom.getAttribute('data-react-name');
      const reactElement = this.elementMap[reactName];
      const domId = scriptDom.getAttribute('data-dom-id');
      const dom = document.getElementById(domId);
      let reactProps = scriptDom.innerHTML;
      if (reactProps) {
        reactProps = JSON.parse(reactProps);
      }

      return {
        dom,
        reactElement,
        reactName,
        reactProps,
      };
    });

    if (components.length !== 0) {
      const rootDom = document.createElement('div');
      document.body.appendChild(rootDom);
      const root = createRoot(rootDom);
      root.render(<App components={components} wrappers={this.wrapperArray} />);
    }
  };

  document.addEventListener('DOMContentLoaded', this.loadComponents);
}

export const reactOnCms = new ReactOnCms();
